<div>
  <ion-text color="primary"><h2>{{[data.translationKey, 'help_dialog', 'title'].join('.') | translate }}</h2></ion-text>
  <ion-text>{{[data.translationKey, 'help_dialog', 'text'].join('.') | translate }}</ion-text>
  <ion-text color="primary"> <h2>{{'WORD_SEARCH.help_dialog.mechanics.howto.title' | translate }}</h2></ion-text>
  <ion-text *ngIf="!isMobile">{{'WORD_SEARCH.help_dialog.mechanics.howto.text.desktop' | translate }}</ion-text>
  <ion-text *ngIf="isMobile">{{'WORD_SEARCH.help_dialog.mechanics.howto.text.mobile' | translate }}</ion-text>
  <ion-text color="primary"><h2>{{'WORD_SEARCH.help_dialog.mechanics.solve.title' | translate }}</h2></ion-text>
  <ion-text>{{'WORD_SEARCH.help_dialog.mechanics.solve.text' | translate }}</ion-text>
  <div *ngIf="hasSolutionWord">
    <ion-text color="primary"><h2>{{'WORD_SEARCH.help_dialog.mechanics.solution_word.title' | translate }}</h2></ion-text>
    <ion-text>{{'WORD_SEARCH.help_dialog.mechanics.solution_word.text' | translate }}</ion-text>
  </div>
</div>

